import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/hair-type"
    exact
    path="/business/showcase/hair-type"
    component={AsyncPage}
  />,
];
